import { useEffect, useState } from 'react';
import { LoadingMode } from '../Components/LoadingMode';
import axios from 'axios';
import { getToken } from '../utils';

function BidForm({ content }) {
  const [isLoading, setIsLoading] = useState(false);
  const { token: userToken } = getToken();
  const [allData, setAllData] = useState({});

  // const [bidData, setbidData] = useState(inputObject);
  const {
    offerDetails,
    setBidData,
    bidData,
    handleSubmitBid,
    isSubmittingBid,
  } = content;
  const handleChange = (e) => {
    const { value, name } = e.target;
    setBidData((input) => ({
      ...input,
      [name]: value,
    }));
    if (bidData.amount !== '' && bidData.rate !== '') {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    // const controller = new AbortController();

    const fetchData = async () => {
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`;
      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });

        setAllData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    // fetchSystemRate();
    // postLocalAccount();

    setIsLoading(false);
    // return () => {
    //   // isMounted = false;
    //   controller.abort();
    // };
  }, [userToken]);

  const formbidData = [
    {
      label: 'Amount',
      type: 'number',
      name: 'amount',
      value: bidData.amount
        ? bidData.amount
        : (bidData.amount = offerDetails?.amount),
      placeholder: '0.00',
      disable: isLoading,
      onChange: handleChange,
      symbol: offerDetails?.quote_currency?.symbol,
      flag: offerDetails?.quote_currency?.country?.flag,
    },
    {
      label: 'Rate',
      type: 'number',
      name: 'rate',
      value: bidData.rate ? bidData.rate : (bidData.rate = offerDetails?.rate),
      placeholder: '0.00',
      disable: isLoading,
      onChange: handleChange,
      symbol: offerDetails?.base_currency?.symbol,
      flag: offerDetails?.base_currency?.country?.flag,
    },
    {
      label: 'Message',
      name: 'message',
      value: bidData.message
        ? bidData.message
        : (bidData.message = offerDetails?.remark),
      disable: isLoading,
      onChange: handleChange,
    },
  ];
  useEffect(() => {
    if (bidData?.amount === '' && bidData?.rate === '') {
      setIsLoading(true);
    }
  }, [bidData.amount, bidData.rate]);

  return (
    <form
      className='w-full h-full flex flex-col gap-10'
      onSubmit={handleSubmitBid}
    >
      <div className='flex flex-col gap-6'>
        {formbidData?.map((input, index) => (
          <div className='flex flex-col gap-2 w-full' key={index}>
            <label className='text-s-bk text-base font-pin'>
              {input.label}
            </label>
            <div className='relative'>
              {input.name === 'message' ? (
                <select
                  name={input.name}
                  className='focus:b-mc w-full h-11 disabled:bg-f-bk rounded-lg border-t-bk border-hf px-4 focus:outline-none focus:ring focus:b-mc'
                  value={input.value}
                  onChange={input.onChange}
                  disabled={isSubmittingBid}
                  required
                >
                  <option value={input.value} className='text-s-bk'>
                    {input.value === '1' ? 'Urgent' : 'Fast Transaction ASAP'}
                  </option>
                  {allData.cx_messages?.map((data) => (
                    <option key={data?.id} value={data?.id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={input.type}
                  className=' focus:b-mc w-full h-11 disabled:bg-f-bk rounded-lg border-t-bk border-hf px-4 focus:outline-none focus:ring focus:b-mc'
                  name={input.name}
                  value={input.value}
                  onChange={input.onChange}
                  placeholder={input.placeholder}
                  disabled={isSubmittingBid}
                  required
                />
              )}
              {input.symbol ? (
                <div className='pr-4 absolute flex flex-row right-0 top-2 gap-2 items-center'>
                  <p>{input.symbol}</p>
                  <img
                    className='w-6 h-4'
                    src={input?.flag}
                    alt='currency flag'
                  />
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <button
        className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-2.5 w-full font-semibold disabled:bg-b-mct bg-b-mc rounded relative'
        // disabled={isSubmittingBid ? isSubmittingBid : isLoading}
      >
        Bid Offer
        {isSubmittingBid && <LoadingMode />}
      </button>
    </form>
  );
}

export default BidForm;
